"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.galleryPop = void 0;
var React = require("react");
var classnames_1 = require("classnames");
var PlaceState_1 = require("@/pages/place/states/PlaceState");
var GoogleMap_1 = require("@/api/vendor/GoogleMap");
var MapLocation_1 = require("@/pages/common/components/MapLocation");
var PlaceGallery_1 = require("@/pages/place/components/PlaceGallery");
var myokay_slider_1 = require("@okay/myokay-slider");
exports.galleryPop = function (props) {
    var miniGalleryClass = 'o-link o-link--nounder o-link--contrast u-stretch u-flex u-flex--middle';
    var galleryPopClass = classnames_1.default([
        'l-fullscreen-dim l-fullscreen-dim--center',
        {
            'l-fullscreen-dim--active': props.galleryPop !== PlaceState_1.GalleryPopState.NONE,
        },
    ]);
    var galleryItems = props.galleryItems.filter(function (it) { return !(Number(it.src).toString() === it.src); });
    // tslint:disable-next-line:max-line-length
    var staticMap = "https://maps.googleapis.com/maps/api/staticmap?center=" + props.lat + "," + props.lng + "&zoom=16&size=150x180&markers=color:0x00b0a8|" + props.lat + "," + props.lng + "&maptype=roadmap&style=feature:all|element:labels|visibility:off&key=" + props.googleApikey;
    // tslint:disable-next-line:max-line-length
    var staticMapSat = "https://maps.googleapis.com/maps/api/staticmap?center=" + props.lat + "," + props.lng + "&zoom=16&size=150x180&markers=color:0x00b0a8|" + props.lat + "," + props.lng + "&maptype=satellite&style=feature:all|element:labels|visibility:off&key=" + props.googleApikey;
    var fullsize = function (index) { return function () { return props.fullsize(index); }; };
    var showPop = function (popState) { return function () {
        return props.showPop(popState);
    }; };
    var showMap = function (type) { return function () {
        props.showPop(PlaceState_1.GalleryPopState.MAP);
        props.setMapType(type);
    }; };
    var backBtn = props.galleryPop === PlaceState_1.GalleryPopState.THUMBS ?
        showPop(PlaceState_1.GalleryPopState.NONE) :
        showPop(PlaceState_1.GalleryPopState.THUMBS);
    var renderMiniMap = function (props) {
        var road = (React.createElement("a", { id: "prop-gallery-minimap-btn", onClick: showMap(GoogleMap_1.GoogleMapType.ROADMAP), className: "js-minimap u-pointer-event--all o-minibox", href: "#" },
            React.createElement("img", { loading: "lazy", className: "o-image", src: staticMap })));
        var sat = (React.createElement("a", { id: "prop-gallery-minimap-btn", onClick: showMap(GoogleMap_1.GoogleMapType.SATELLITE), className: "u-pointer-event--all o-minibox", href: "#" },
            React.createElement("img", { loading: "lazy", className: "o-image", src: staticMapSat })));
        return props.mapType === GoogleMap_1.GoogleMapType.SATELLITE ?
            road : sat;
    };
    var renderMiniGallery = function (props) {
        return (React.createElement("a", { id: "prop-gallery-minigallery-icon", onClick: showPop(PlaceState_1.GalleryPopState.THUMBS), className: "u-pointer-event--all o-minibox", href: "#" },
            React.createElement("div", { className: miniGalleryClass },
                React.createElement("span", { className: "u-text-center" },
                    React.createElement("span", { className: "fal fa-images", style: { lineHeight: '24px' } }),
                    React.createElement("br", null),
                    React.createElement("span", { className: "u-mobile-hidden" },
                        galleryItems.length,
                        " ",
                        props.t.photos)))));
    };
    var renderRoadmap = function (props) {
        return renderMap(props, GoogleMap_1.GoogleMapType.ROADMAP);
    };
    var renderMap = function (props, mapType) {
        var mapProp = {
            mapType: mapType,
            id: 'place-map',
            name: props.name,
            lat: props.lat,
            lng: props.lng,
        };
        return (React.createElement("div", { id: "prop-gallery-map", className: "u-stretch u-flex__flex" },
            React.createElement(MapLocation_1.default, __assign({}, mapProp))));
    };
    var renderFull = function (props) { return (React.createElement("div", { id: "gallery-full" },
        React.createElement(PlaceGallery_1.PlaceGalleryComponent, { width: props.galleryFullWidth, height: '100vh', items: galleryItems, slideIndex: props.galleryIndex }))); };
    var renderThumbs = function (props) {
        var renderThumb = function (props, item, i) {
            var imgsrc = myokay_slider_1.isVideo(item.src) ? item.thumb : item.src;
            return (React.createElement("a", { key: i, href: "#", className: "l-gridlist__item c-gallery-grid-item", style: { padding: 0 }, onClick: fullsize(i) },
                React.createElement("img", { className: "o-image", src: imgsrc })));
        };
        return (React.createElement("div", { id: "place-gallery-thumbs", style: { display: 'flex', flex: 1, height: '100%', minHeight: 0 } },
            React.createElement("div", { className: "u-flex__flex l-gridlist l-gridlist--grid l-gridlist--gallery" },
                React.createElement("div", { className: "l-gridlist__body l-gridlist__body" }, galleryItems.map(function (it, i) { return renderThumb(props, it, i); })))));
    };
    var topBarClass = classnames_1.default([
        'c-topbar',
        {
            'c-topbar--solid': props.galleryPop === PlaceState_1.GalleryPopState.THUMBS,
        },
    ]);
    var hasLatLng = props.lat && props.lng ? true : false;
    var hasPhoto = galleryItems && galleryItems.length ? true : false;
    return (React.createElement("div", { id: "prop-gallery-pop", className: galleryPopClass },
        React.createElement("div", { className: "u-stretch u-flex u-flex--column", style: { backgroundColor: '#000' } },
            React.createElement("div", { className: topBarClass },
                React.createElement("div", { className: "c-topbar__wrapper" },
                    React.createElement("a", { id: "prop-gallery-back", onClick: backBtn, href: "#", className: "c-topbar__close" },
                        React.createElement("span", { className: "u-line-icon-pro icon-arrow-left" }),
                        " ",
                        props.t.back),
                    React.createElement("div", { id: "prop-gallery-title", className: "c-topbar__title" }, props.nameMain),
                    React.createElement("div", { className: "c-topbar__right" },
                        React.createElement("a", { id: "prop-gallery-close", onClick: showPop(PlaceState_1.GalleryPopState.NONE), className: "c-topbar__close", href: "#" },
                            React.createElement("span", { className: "u-line-icon-pro icon-close" }),
                            " ",
                            props.t.close)))),
            React.createElement("div", { className: "u-stretch u-flex__flex u-flex u-flex--middle", style: { minHeight: 0 } },
                props.galleryPop === PlaceState_1.GalleryPopState.FULL ? renderFull(props) : '',
                props.galleryPop === PlaceState_1.GalleryPopState.THUMBS ? renderThumbs(props) : '',
                props.galleryPop === PlaceState_1.GalleryPopState.MAP ? renderRoadmap(props) : '',
                React.createElement("div", { className: "u-anchor-bottom u-pointer-event--none" },
                    React.createElement("div", { style: { paddingRight: '20px' } },
                        React.createElement("div", { style: { display: 'flex', justifyContent: 'flex-end' } },
                            hasPhoto ? renderMiniGallery(props) : '',
                            hasLatLng ? renderMiniMap(props) : '')))))));
};
